import { Route, Routes } from 'react-router-dom'
import PropTypes from 'prop-types'
import AuthorizedView from './components/common/authirization/AuthorizedView.jsx'

const UserTypes = (props) => {
    if (!props.routes) return <div>Brak danych</div>
    if (props.type !== props.current) return null

    return (
        <>
            <Routes>
                {props.routes.map((r, i) => {
                    return (
                        <Route
                            key={i}
                            path={r.path}
                            element={
                                <AuthorizedView roles={r.roles} mode={r.mode}>
                                    {r.view}
                                </AuthorizedView>
                            }
                        ></Route>
                    )
                })}
            </Routes>
        </>
    )
}

UserTypes.propTypes = {
    routes: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            exact: PropTypes.bool,
            roles: PropTypes.array,
            forbidden: PropTypes.bool,
            view: PropTypes.element.isRequired,
            mode: PropTypes.string,
        })
    ).isRequired,
    type: PropTypes.oneOf(['/oper', '/wp', '/reporter']).isRequired,
    current: PropTypes.oneOf(['/oper', '/wp', '/reporter']).isRequired,
}

export default UserTypes
